import ClubGoalChip from './ClubGoalChip';

export default ClubGoalChip;
